import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getSkill = id => {
  return dispatch => {
    dispatch({ type: "GET_SKILL_LOADING" });
    api
      .skillGet(id)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchSkillErrorAlertTitle",
          "Virhe taidon lukemisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_SKILL_SUCCEEDED",
  payload: { skill: data },
});

const operationFail = () => ({
  type: "GET_SKILL_FAIL",
});
